import { isInWps } from '@/common/utils';
import wpsoffice from '@wps/wps_client_api/wpsoffice';

class FeedBackLink {
  constructor() {
    this.FEEDBACK_BASE_URL = process.env.FEEDBACK_BASE_URL;
    this.url = '';
  }

  async createFeedBackLink() {
    const product_id = 8000004,
      product_name = encodeURIComponent('WPS学堂');
    let url = `${process.env.FEEDBACK_BASE_URL}?product_id=${product_id}&product_name=${product_name}&tofeedback=true`;
    // 端内添加客户端参数
    if (isInWps()) {
      const res = await wpsoffice.getAppInfo().catch(() => {
        return {};
      });
      const {
        version: app_version,
        hdid: app_hdid,
        channel: app_dist,
        appname: app_name,
      } = res;
      url += `&app_type=client&app_version=${app_version}&app_hdid=${app_hdid}&app_dist=${app_dist}&app_name=${app_name}`;
    } else {
      url += `&app_type=web`;
    }
    this.url = url;
  }

  async getUrl() {
    await this.createFeedBackLink();
    return this.url;
  }
}

export default new FeedBackLink();
